var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaelanoTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 19,
    viewBox: "0 0 126 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12717_7301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5693H3.79226V9.62918L8.11808 15.2591L9.70554 15.2168L14.0732 9.92971V18.5693H17.8435V0.366261H16.88L9.5975 10.2703H8.92283L0.471828 0.0234375L0 0.495377V18.5693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6337 0.515625L19.0879 18.5673H22.8779L31.4899 0.515625H27.6337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3688 10.832L33.8049 18.5678H29.3688L27.25 14.12L29.3688 10.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7031 0.515625V18.5673H48.6485V15.1502H38.3014V11.3457H47.491V8.18686H38.4292V4.19096H48.6485V0.515625H34.7031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8633 0.515625V18.5673H65.8087V15.0211H55.7195V0.515625H51.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9922 18.5673L77.1179 0.515625H78.3393L87.207 18.5673H82.965L77.6007 7.47895L74.611 13.1511L79.2389 13.2802L79.1749 16.4391L72.7479 16.5037L71.7205 18.5673H67.9922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4922 0V18.5681H92.1544L92.4123 8.6396L103.915 18.5681L104.173 0.516462H100.702L100.766 10.7032L88.4922 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.578 0.0859375C111.372 0.0859375 107.152 4.32003 107.152 9.54253C107.152 12.4343 108.449 15.0255 110.488 16.7596L112.561 13.1578C111.703 12.1983 111.181 10.9294 111.181 9.54253C111.181 6.55061 113.597 4.12636 116.58 4.12636C119.563 4.12636 121.977 6.55061 121.977 9.54253C121.977 12.5344 119.561 14.9587 116.58 14.9587C116.461 14.9587 116.346 14.9565 116.232 14.9453L114.093 18.6652C114.887 18.8834 115.718 18.9991 116.58 18.9991C121.786 18.9991 126.003 14.765 126.003 9.54253C126.003 4.32003 121.781 0.0859375 116.578 0.0859375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12717_7301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaelanoTextIcon);
export default __webpack_public_path__ + "static/media/MaelanoTextIcon.56262a862844d4503f073064a8ed4134.svg";
export { ForwardRef as ReactComponent };